import React from 'react';
import styled from '@emotion/styled';

import { Grid, Typography } from '@mui/material';
import { useAuth } from '../../contexts/auth/useAuth';

const Footer = styled.div`
  background-color: ${import.meta.env.REACT_APP_BUILD === 'staging'
    ? 'var(--color-staging-navigation)'
    : 'var(--color-deep-ocean-blue)'};
`;

const FooterText = styled(Typography)`
  color: var(--color-light-greyish-blue);
`;

const SidebarFooter: React.FC = ({ ...rest }) => {
  const { user } = useAuth();
  return (
    <Footer {...rest}>
      <Grid
        container
        paddingX={12}
        paddingY={12}
        display="flex"
        flexDirection="column"
      >
        <Grid item sx={{ textAlign: 'center' }}>
          {!!user && (
            <FooterText
              variant="body1"
              sx={{
                maxWidth: '190px',
                overflow: 'hidden',
                fontSize: '14px',
                textOverflow: 'ellipsis',
                fontWeight: 600,
              }}
            >
              {user.email}
            </FooterText>
          )}
        </Grid>
      </Grid>
    </Footer>
  );
};

export default SidebarFooter;
